






















































































import { Component, Inject, Vue } from 'vue-property-decorator';
import ViewMap from '@/views/dataView/ziYangDataViewBlack/unit/viewMap.vue';
import BoxLeftCompany1 from '@/views/dataView/ziYangDataViewBlack/unit/right/box2.vue';
import BoxLeft1 from '@/views/dataView/ziYangDataViewBlack/unit/left/box1new.vue';
import BoxLeft2 from '@/views/dataView/ziYangDataViewBlack/unit/left/box1.vue';
import BoxLeft3 from '@/views/dataView/ziYangDataViewBlack/unit/left/box2.vue';
import BoxRight1 from '@/views/dataView/ziYangDataViewBlack/unit/right/box1.vue';
import BoxRight2 from '@/views/dataView/ziYangDataViewBlack/unit/left/box3.vue';
import BoxRight3 from '@/views/dataView/ziYangDataViewBlack/unit/right/box3.vue';

import CompanyDialog from '@/views/dataView/ziYangDataViewBlack/rcDialog/companyDialog.vue';

import AlarmDialogList from '@/views/dataView/ziYangDataViewBlack/rcDialog/alarmDialogList.vue';
import AlarmDialogStatic from '@/views/dataView/ziYangDataViewBlack/rcDialog/alarmDialogStatic.vue';
import RiskEntList from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box4/riskEntList.vue';
import { regionServe, zyScreenServer } from '@/api/installServer';
import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数
import { UserModule } from '@/store/modules/user';

@Component({
  components: { CollapseTransition, ViewMap, BoxLeft1, BoxLeft2, BoxLeft3, BoxRight1, BoxRight2, BoxRight3, BoxLeftCompany1, CompanyDialog, AlarmDialogList, AlarmDialogStatic, RiskEntList },
})
export default class ZiYangDataViewNew extends Vue {
  @Inject() reload: any;
  private entName: any = '安全生产监测预警平台';
  private rygGroup: any = true;
  private showAlertList: any = false;
  private asideShowLeft: any = true;
  private asideShowRight: any = true;

  private currentFlag: any = false;
  private isCompany: any = false;

  private alertAllData: any = [];
  private entForm: any = {};

  private entRiskLevelNum: any = {
    red: 0,
    yellow: 0,
    green: 0,
  };
  showEntInfo() {
    if (this.entName !== '安全生产监测预警平台') {
      const form: any = {
        id: this.entForm.id,
      };
      (this.$refs.CompanyDialogRef as any).showDialog(form);
    }
  }

  setEntPoint(data: any) {
    (this.$refs.viewMapRef as any).setEntPoint(data);
  }

  entChange(data: any) {
    this.isCompany = true;
    this.rygGroup = false;
    this.entName = data.companyName;
    this.entForm = data;
    this.getAlarmCountData(data.id);

    (this.$refs.BoxLeftCompany1 as any).getData({ deptId: data.id });
    (this.$refs.BoxLeft2 as any).getData({ deptId: data.id });
    (this.$refs.BoxLeft3 as any).getData({ areaId: data.areaId });
    (this.$refs.BoxRight1 as any).getData({ deptId: data.id });
    (this.$refs.BoxRight2 as any).getCountAllData({ deptId: data.id, areaId: data.areaId });
    (this.$refs.BoxRight3 as any).getCountAllData({ deptId: data.id });
  }
  backMainIndex() {
    this.reload();
  }
  showModuleLeft(flag: boolean) {
    this.asideShowLeft = flag;
  }
  showModuleRight(flag: boolean) {
    this.asideShowRight = flag;
  }

  viewEntInfo(type: any) {
    (this.$refs.RiskEntListRef as any).showDialog(type);
  }

  showDetailDialog(data: any) {
    const companyId: any = data.companyId;
    (this.$refs.AlarmDialogListRef as any).showDialog(companyId);
  }
  showMoreDialog() {
    (this.$refs.AlarmDialogStaticRef as any).showDialog();
  }
  private enterSystem() {
    UserModule.clearUserInfo();
    this.$router.push('/index');
  }
  mounted() {
    this.getToken();
    this.getRiskNum();
    const userInfo = JSON.parse((localStorage as any).getItem('userInfo'));
    if (userInfo.deptType === '5' || userInfo.deptType === '6') {
      this.isCompany = true;
      this.currentFlag = true;
      this.getAlarmCountData(userInfo.deptId);
    } else {
      this.currentFlag = false;
      this.getAlarmCountData(null);
    }
  }
  getToken() {
    regionServe.getVideoToken().then((res: any) => {
      window.localStorage.setItem('videoToken', res.data);
    });
  }
  getRiskNum() {
    zyScreenServer.getCompanyCount().then((res: any) => {
      if (res.code === '200') {
        this.entRiskLevelNum = res.data;
      }
    });
  }
  getAlarmCountData(id: any) {
    zyScreenServer
      .getAlarmStatisticData({
        companyId: id || null,
      })
      .then((res: any) => {
        if (res.data && res.data.length) {
          this.alertAllData = res.data;
        }
      });
  }
}
